import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import SingleFieldManager from "@com/SingleFieldManager.vue";
export default {
  __name: 'HotelLabelManager',

  setup(__props) {
    const config = {
      name: '酒店标签',
      type: 'hotelLabel',
      route: 'hotellabelmanager'
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(SingleFieldManager, {
        config: config
      });
    };
  }

};